import { render, staticRenderFns } from "./ScrollPabe.vue?vue&type=template&id=3cacc0a0&scoped=true"
import script from "./ScrollPabe.vue?vue&type=script&lang=js"
export * from "./ScrollPabe.vue?vue&type=script&lang=js"
import style0 from "./ScrollPabe.vue?vue&type=style&index=0&id=3cacc0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cacc0a0",
  null
  
)

/* custom blocks */
import block0 from "./ScrollPabe.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports